import { Injectable } from '@angular/core';
import {
  IWorkflowTaskPayload,
  IWorkflowTaskResponse,
} from '@g99-product-web-ui/shared-interface-lib';
import { API_ENDPOINTS } from '@g99-product-web-ui/shared-util-lib';
import { Observable } from 'rxjs';

import { HttpService } from '../../core/http-service/http.service';
import { IContactsResponse } from '../../interfaces/shared-add-edit.interface';

@Injectable({
  providedIn: 'root',
})
export class TasksService {
  constructor(private readonly _httpService: HttpService) {}

  /* -------------------------------------------------------------------------- */
  /*                               get task Details                           */
  /* -------------------------------------------------------------------------- */
  public getTaskDetails(taskId: number): Observable<IWorkflowTaskResponse> {
    const apiUrl = `${API_ENDPOINTS.TASKS_ENDPOINTS.base}/${taskId}`;
    return this._httpService.get<IWorkflowTaskResponse>(apiUrl);
  }

  /* -------------------------------------------------------------------------- */
  /*                              update task                           */
  /* -------------------------------------------------------------------------- */
  public updateTask(
    data: IWorkflowTaskPayload,
    taskId: number
  ): Observable<IWorkflowTaskResponse> {
    const apiUrl = `${API_ENDPOINTS.TASKS_ENDPOINTS.base}/${taskId}`;
    return this._httpService.put<IWorkflowTaskResponse, IWorkflowTaskPayload>(
      apiUrl,
      data
    );
  }

  /* -------------------------------------------------------------------------- */
  /*                              create new task                           */
  /* -------------------------------------------------------------------------- */
  public createTask(
    data: IWorkflowTaskPayload
  ): Observable<IWorkflowTaskResponse> {
    const apiUrl = `${API_ENDPOINTS.TASKS_ENDPOINTS.base}`;
    return this._httpService.post<IWorkflowTaskResponse, IWorkflowTaskPayload>(
      apiUrl,
      data
    );
  }

  /* ------------------------ get contacts dropdown list ---------------------- */
  public getContactsDropdown(): Observable<IContactsResponse> {
    return this._httpService.get<IContactsResponse>(
      API_ENDPOINTS.CONTACTS_ENDPOINTS.getContactsDropdown()
    );
  }
}
